import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudAvatarModule, FreudBadgeModule } from '@freud-ds/web-components';

import { UserAvatarComponent } from './user-avatar.component';

@NgModule({
	declarations: [UserAvatarComponent],
	imports: [CommonModule, FreudAvatarModule, FreudBadgeModule],
	exports: [UserAvatarComponent],
	providers: [],
})
export class UserAvatarModule {}
